export const routeName = 'live-counter';
export const slugs: Record<string, string> = {
	en: 'live-counter',
	es: 'contador-en-vivo',
	ca: 'comptador-en-directe',
	it: 'contatore-in-diretta',
};
